export interface PerfilDTO {
  telefone: string;
  nome: string;
  endereco: {
    rua: string;
    numero: string;
    bairro: string;
    cidade: string;
    estado: string;
    cep: string;
    complemento?: string;
  };
  formaPagamento?: string;
}

export const getPerfil = async (_telefone: string): Promise<PerfilDTO | null> => {
  return null;
};

export const salvarPerfil = async (perfil: PerfilDTO): Promise<PerfilDTO> => {
  return {
    ...perfil,
    telefone: perfil.telefone.replace(/\D/g, ''),
  };
};
